import { render, staticRenderFns } from "./kalemrestaurant.vue?vue&type=template&id=9947dc56&"
import script from "./kalemrestaurant.vue?vue&type=script&lang=js&"
export * from "./kalemrestaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports